import React from 'react';
import { AlertCircle } from 'lucide-react';
export function WowMomentSection() {
  return <section className="bg-navy text-background py-4 md:py-14 px-6" data-id="element-395">
      <div className="max-w-4xl mx-auto" data-id="element-396">
        <div className="flex flex-col items-center text-center mb-10" data-id="element-397">
          <div className="bg-accent/20 p-4 rounded-full mb-6" data-id="element-398">
            <AlertCircle className="w-10 h-10 text-amber" data-id="element-399" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold leading-tight" data-id="element-400">
            Antes de que sigas leyendo, quiero quitarte un peso de encima:{' '}
            <span className="text-amber" data-id="element-401">
              Sentirte así NO es normal. Y no tiene que ver con tu edad.
            </span>
          </h2>
        </div>

        <div className="bg-white/5 p-8 md:p-12 rounded-2xl border border-white/10 shadow-2xl" data-id="element-402">
          <p className="text-lg md:text-xl leading-relaxed text-background/90" data-id="element-403">
            Nos han vendido la mentira de que "es la edad", que el metabolismo
            se arruina por el calendario y que es natural despertarse como si te
            hubieran dado una paliza.{' '}
            <strong className="text-amber font-semibold" data-id="element-404">Es mentira.</strong>
            <br data-id="element-405" />
            <br data-id="element-406" />
            La <strong className="text-background" data-id="element-407">falta de energía</strong> no
            tiene nada que ver con los años que tenés, sino con el tipo de{' '}
            <strong className="text-amber" data-id="element-408">"basura"</strong> que tus células
            están tratando de procesar. Tu cuerpo está diseñado para ser una{' '}
            <strong className="text-background" data-id="element-409">máquina de energía</strong>{' '}
            hasta el último día, siempre y cuando dejes de darle el{' '}
            <strong className="text-amber" data-id="element-410">combustible equivocado</strong>.
          </p>
        </div>
      </div>
    </section>;
}